export const SET_SELECTED = "SET_SELECTED"
export const SET_LIST= "SET_LIST"
export const SET_TO_UPDATE = "SET_TO_UPDATE"



// WEBPACK FOOTER //
// ./src/features/Pergunta/store/mutations-types.js